import React from 'react';

function Field({ label, optional, children, className = '' }) {
  return (
    <label className={`field ${className}`}>
      <span className="field__label">
        {label}
        {optional && <em>Optional</em>}
      </span>
      {children}
    </label>
  );
}

export default Field;